import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import { ChevronDown } from 'lucide-react';
import { useMySellerLists, type SellerList } from '~/api/sellerLists';

type SellerListSelectProps = {
  testId: string;
  disabled?: boolean;
  className?: string;
  labels: { apply: string; option: (name: string, count: number) => string };
  onApply: (sellerList: SellerList) => void;
};

export function SellerListSelect({
  testId,
  disabled,
  className,
  labels,
  onApply,
}: Readonly<SellerListSelectProps>) {
  const { data } = useMySellerLists();
  const sellerLists = data?.mySellerLists ?? [];

  if (sellerLists.length === 0) return null;

  return (
    <div className={className}>
      <DropdownMenu.Root>
        <DropdownMenu.Trigger asChild disabled={disabled}>
          <button
            type="button"
            data-testid={testId}
            className="flex items-center gap-2 w-fit text-sm border border-neut-300 rounded-lg px-3 py-1.5 cursor-pointer focus:outline-none focus-visible:ring-2 focus-visible:ring-prim disabled:cursor-not-allowed disabled:opacity-50"
          >
            {labels.apply}
            <ChevronDown size={16} />
          </button>
        </DropdownMenu.Trigger>
        <DropdownMenu.Portal>
          <DropdownMenu.Content
            side="bottom"
            align="start"
            sideOffset={4}
            className="min-w-[160px] bg-neut-0 border border-neut-200 rounded-lg shadow-drop py-1 z-[1100]"
          >
            {sellerLists.map((list) => (
              <DropdownMenu.Item
                key={list.id}
                data-testid={`${testId}-option-${list.id}`}
                disabled={list.members.length === 0}
                onSelect={() => onApply(list)}
                className="px-3 py-2 text-sm cursor-pointer outline-none select-none text-neut-700 data-[highlighted]:bg-neut-100 data-[disabled]:opacity-50 data-[disabled]:cursor-not-allowed"
              >
                {labels.option(list.name, list.members.length)}
              </DropdownMenu.Item>
            ))}
          </DropdownMenu.Content>
        </DropdownMenu.Portal>
      </DropdownMenu.Root>
    </div>
  );
}
